import React, { useState, useEffect }  from 'react';
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { googleMapsApiKey } from "index";

const defaultMapOptions = {
  mapTypeControl: false,
  cameraControl: false,
  minZoom: 4,
  maxZoom: 20,
  disableDoubleClickZoom: false
  // scrollwheel: false,
};
const scriptLibraries = ['geometry', 'drawing', 'places'];

const MapWrapper = React.memo(props => {
  const { zoom, center, onZoomChanged, onCenterChanged, mapOptions, mapViewType, gestureHandling, children } = props;
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    libraries: scriptLibraries,
    version: '3.64'
  })

  const [mapRef, setMapRef] = useState(null);
  const [streetViewListener, setStreetViewListener] = useState(null);
  const [isStreetView, setIsStreetView] = useState(false);

  useEffect(() => {
    return ()  => {
      if (streetViewListener) {
        window.google.maps.event.removeListener(streetViewListener);
      }
    }
  }, [streetViewListener])

  const onLoad = map => {
    setMapRef(map);
    const streetViewListener = window.google.maps.event.addListener(map.getStreetView(), 'visible_changed', () => {
      setIsStreetView(map.getStreetView().getVisible());
    });
    setStreetViewListener(streetViewListener);
  }

  if (!isLoaded) return null;

  return (
    <GoogleMap
      onLoad={onLoad}
      mapContainerStyle={{ height: `100%`, width: `100%`, minHeight: '100px' }}
      zoom={zoom}
      center={center}
      onZoomChanged={() => onZoomChanged(mapRef)}
      onCenterChanged={() => onCenterChanged(mapRef)}
      options={{
        ...mapOptions ?? defaultMapOptions,
        mapTypeId: mapViewType,
        gestureHandling
      }}
      // mapTypeId={mapViewType}
      // gestureHandling={gestureHandling}
    >
      {mapRef && children
        ? React.cloneElement(children, {...props, map: mapRef, isStreetView })
        : null
      }
    </GoogleMap>
  )
  
}, (prevProps, nextProps) => {
  let skipUpdate = false;
  //no need to modify current map, props are for recreating map
    if (prevProps.zoom !== nextProps.zoom) {
      skipUpdate = true;
    }
    if (prevProps.center && (prevProps.center.lat !== nextProps.center.lat || prevProps.center.lng !== nextProps.center.lng)) {
      skipUpdate = true;
    }
    if (prevProps.gestureHandling !== nextProps.gestureHandling) {
      skipUpdate = true;
    }
    if (prevProps.mapViewType !== nextProps.mapViewType) {
      skipUpdate = true;
    }
  
  return skipUpdate;
});

export default MapWrapper;